<template>
  <div style="margin:-20px">
    <div v-if="!isBinding" :class="isPc == 'pc' ? 'widget_list gridster' : 'widget_list gridster phone_weight'">
      <div class="binding" v-if="roleUserInfo.shortCode == 'P'">
        <div class="user_img">
          <img v-if="childrens.avatar" :src="imgUrl + childrens.avatar">
          <img v-else src="../appframe/img/role/role2.png">
        </div>
        <div class="user_info">
          <p>{{childrens.studentName}}</p>
          <p>{{childrens.schoolName}}</p>
        </div>
        <div class="user_btn">
          <el-button @click="checkDialog = true" >切换</el-button>
        </div>
      </div>
      <ul :key='refreshwidget' ref="widget" v-if="widgetListsData.length > 0">
        <li class="widget_item" v-for="(widget,index) in widgetListsData" v-if="widget.isAdd == 1" :data-size="widget.swWidth" :key="index"
          :swId="widget.swId" :swCode="widget.swCode" :data-row="widget.positionX" :data-col="widget.positionY" :data-sizex="widget.swWidth"
          :data-sizey="1" :data-equip="widget.swName + 'X' + widget.swWidth" :widget-name="widget.swCode">
          <component :is="widget.swCode" :title="widget.swName" :swWidth="widget.swWidth" :item="widget" v-if="isShowWidgetCont"></component>
        </li>
      </ul>
      <div class="add_bar" @click="showWeightAdd">
        <i class="el-icon-circle-plus"></i>
      </div>
    </div>
    <el-dialog title="添加小部件" :visible.sync="dialogVisible" width="50%" class="weight_add_dialog">
      <div class="add_widget_list" v-loading="addLoading">
        <ul v-if="widgetListUpdate.length > 0" class="add_weight">
          <li v-for="(widget,index) in widgetListUpdate" class="add_weight_list" :key="index">
            <div class="check" v-if="widget.isAdd == 1">
              <i class="el-icon-check"></i>
            </div>
            <div class="weight_name">{{widget.swName}}</div>
            <div class="widget_img">
              <img :src="imgsrc(widget.swCode,widget.swWidth)" @error="errorImg($event,'image')">
            </div>
            <div class="weight_chose">
              <div v-if="widget.isAdd == 1" class="weight_bar remove_btn" @click="widget.isAdd = 0">
                <i class="el-icon-minus"></i>移除</div>
              <div v-if="widget.isAdd == 0" class="weight_bar add_btn" @click="widget.isAdd = 1">
                <i class="el-icon-plus"></i>添加</div>
                <template v-if="!widget.isType">
                  <span :class="{is_active:widget.swWidth == 1}" @click="widget.swWidth = 1">X1</span>
                  <span :class="{is_active:widget.swWidth == 2}" @click="widget.swWidth = 2">X2</span>
                  <span :class="{is_active:widget.swWidth == 3}" @click="widget.swWidth = 3">X3</span>
                </template>
            </div>
          </li>
        </ul>
      </div>
      <div class="noData" v-if="!addLoading && widgetListUpdate.length == 0"><img src="@/img/icon_emptypage.png"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureUpdate" v-if="!addLoading && widgetListUpdate.length > 0">确 定</el-button>
        <el-button type="primary" @click="dialogVisible = false" v-if="!addLoading && widgetListUpdate.length == 0">返回</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="切换绑定"
      :visible.sync="checkDialog"
      width="700px"
      class="listBox"
      :before-close="handleClose">
      <div >
        <div class="childrenList" v-for="(c,index) in childrenList" :key="c.id">
          <el-checkbox class="el_checkbox" @change="changeChildren(c,index)" v-model="c.checkeds"></el-checkbox>
          <div class="list_children" :class="c.checkeds ?'listDefaul':'listOthers'" >
            <div class="list_label defaul_color" v-show="c.choosed"> 默认  </div>
            <div class="list_img">
              <img v-if="c.avatar" :src="imgUrl + c.avatar">
              <img v-else src="../appframe/img/role/role2.png">
            </div>
            <div class="list_info">
              <p>{{c.studentName}}</p>
              <p>{{c.schoolName}}</p>
            </div>
            <div class="list_btn">
              <span>
                <el-checkbox max="1" @change="checkDefaul(c,index)" v-model="c.choosed" style="margin-right: 4px;"><span style="color:#fff;">设为默认</span></el-checkbox>
              </span>
              <span @click="delChildren(c,index)"><i class="el-icon-delete"></i>解绑</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="creatNew" style="float: left; margin-left: 50px;"><i class="el-icon-plus"></i>添加新的绑定</el-button>
        <el-button @click="closedBtn">取 消</el-button>
        <el-button type="primary" @click="enterBtn">确 定</el-button>
      </span>
    </el-dialog>
    <bin_Ding v-if="isBinding" @backHome="backHome" loingType="0" />
  </div>
</template>
<script>
  import TIMETABLE_WIDGET_1 from './img/timetable_widget_1.png'
  import TIMETABLE_WIDGET_2 from './img/timetable_widget_2.png'
  import TIMETABLE_WIDGET_3 from './img/timetable_widget_3.png'
  import TRAINING_WIDGET_1 from './img/training_widget_1.png'
  import TRAINING_WIDGET_2 from './img/training_widget_2.png'
  import TRAINING_WIDGET_3 from './img/training_widget_3.png'
  import RESOURCE_WIDGET_1 from './img/resource_widget_1.png'
  import RESOURCE_WIDGET_2 from './img/resource_widget_2.png'
  import RESOURCE_WIDGET_3 from './img/resource_widget_3.png'
  import NETWORK_WIDGRT_1 from './img/network_widgrt_1.png'
  import NETWORK_WIDGRT_2 from './img/network_widgrt_2.png'
  import NETWORK_WIDGRT_3 from './img/network_widgrt_3.png'
  import COURSE_ARRANGE_WIDGET_1 from './img/course_arrange_widget_1.png'
  import COURSE_ARRANGE_WIDGET_2 from './img/course_arrange_widget_2.png'
  import COURSE_ARRANGE_WIDGET_3 from './img/course_arrange_widget_3.png'
  import COURSE_SELECTION_WIDGET_1 from './img/course_selection_widget_1.png'
  import COURSE_SELECTION_WIDGET_2 from './img/course_selection_widget_2.png'
  import COURSE_SELECTION_WIDGET_3 from './img/course_selection_widget_3.png'
  import PREPARE_WIDGET_1 from './img/prepare_widget_1.png'
  import PREPARE_WIDGET_2 from './img/prepare_widget_2.png'
  import PREPARE_WIDGET_3 from './img/prepare_widget_3.png'
  import SOCIAL_WIDGET_1 from './img/social_widget_1.png'
  import SOCIAL_WIDGET_2 from './img/social_widget_2.png'
  import SOCIAL_WIDGET_3 from './img/social_widget_3.png'
  import MASTER_STUDIO_MANAGE_1 from './img/master_studio_manage_1.png'
  import MASTER_STUDIO_MANAGE_2 from './img/master_studio_manage_2.png'
  import MASTER_STUDIO_MANAGE_3 from './img/master_studio_manage_3.png'
  import MASTER_STUDIO_MEMBER_1 from './img/master_studio_member_1.png'
  import MASTER_STUDIO_MEMBER_2 from './img/master_studio_member_2.png'
  import MASTER_STUDIO_MEMBER_3 from './img/master_studio_member_3.png'

  //zj
  import STUDENT_ACHIEVEMENT_WIDGET_1 from './img/zj_achievement_widget_1.png'
  import SCHOOL_CALENDAR_WIDGET_3 from './img/zj_calendar_widget_3.png'
  import ZJ_COURSE_SELECTION_WIDGET_1 from './img/zj_course_selection_widget_1.png'
  import EVALUATION_INFO_WIDGET_2 from './img/zj_teacher_info_widget_2.png'
  import TEACHER_WORKLOAD_WIDGET_2 from './img/zj_teacher_num_widget_2.png'
  let imgArr = []
  imgArr = 
   [
    {'TIMETABLE_WIDGET_1':TIMETABLE_WIDGET_1},//课表
    {'TIMETABLE_WIDGET_2':TIMETABLE_WIDGET_2},//课表
    {'TIMETABLE_WIDGET_3':TIMETABLE_WIDGET_3},//课表
    {'TRAINING_WIDGET_1':TRAINING_WIDGET_1},//培训学习
    {'TRAINING_WIDGET_2':TRAINING_WIDGET_2},//培训学习
    {'TRAINING_WIDGET_3':TRAINING_WIDGET_3},//培训学习
    {'RESOURCE_WIDGET_1':RESOURCE_WIDGET_1},//资源中心
    {'RESOURCE_WIDGET_2':RESOURCE_WIDGET_2},//资源中心
    {'RESOURCE_WIDGET_3':RESOURCE_WIDGET_3},//资源中心
    {'NETWORK_WIDGRT_1':NETWORK_WIDGRT_1},//网络研修
    {'NETWORK_WIDGRT_2':NETWORK_WIDGRT_2},//网络研修
    {'NETWORK_WIDGRT_3':NETWORK_WIDGRT_3},//网络研修
    {'COURSE_ARRANGE_WIDGET_1':COURSE_ARRANGE_WIDGET_1},//排课系统
    {'COURSE_ARRANGE_WIDGET_2':COURSE_ARRANGE_WIDGET_2},//排课系统
    {'COURSE_ARRANGE_WIDGET_3':COURSE_ARRANGE_WIDGET_3},//排课系统
    {'COURSE_SELECTION_WIDGET_1':COURSE_SELECTION_WIDGET_1},//选课系统
    {'COURSE_SELECTION_WIDGET_2':COURSE_SELECTION_WIDGET_2},//选课系统
    {'COURSE_SELECTION_WIDGET_3':COURSE_SELECTION_WIDGET_3},//选课系统
    {'PREPARE_WIDGET_1':PREPARE_WIDGET_1},//协同备课
    {'PREPARE_WIDGET_2':PREPARE_WIDGET_2},//协同备课
    {'PREPARE_WIDGET_3':PREPARE_WIDGET_3},//协同备课
    {'SOCIAL_WIDGET_1':SOCIAL_WIDGET_1},//网络社交
    {'SOCIAL_WIDGET_2':SOCIAL_WIDGET_2},//网络社交
    {'SOCIAL_WIDGET_3':SOCIAL_WIDGET_3},//网络社交
    {'MASTER_STUDIO_MANAGE_1':MASTER_STUDIO_MANAGE_1},//名师工作室-管理员
    {'MASTER_STUDIO_MANAGE_2':MASTER_STUDIO_MANAGE_2},//名师工作室-管理员
    {'MASTER_STUDIO_MANAGE_3':MASTER_STUDIO_MANAGE_3},//名师工作室-管理员
    {'MASTER_STUDIO_MEMBER_1':MASTER_STUDIO_MEMBER_1},//名师工作室-成员
    {'MASTER_STUDIO_MEMBER_2':MASTER_STUDIO_MEMBER_2},//名师工作室-成员
    {'MASTER_STUDIO_MEMBER_3':MASTER_STUDIO_MEMBER_3},//名师工作室-成员
    {'STUDENT_ACHIEVEMENT_WIDGET_1':STUDENT_ACHIEVEMENT_WIDGET_1},//职教-学生成绩
    {'SCHOOL_CALENDAR_WIDGET_3':SCHOOL_CALENDAR_WIDGET_3},//职教-校历
    {'ZJ_COURSE_SELECTION_WIDGET_1':ZJ_COURSE_SELECTION_WIDGET_1},//职教-选修课信息
    {'EVALUATION_INFO_WIDGET_2':EVALUATION_INFO_WIDGET_2},//职教-评教信息
    {'TEACHER_WORKLOAD_WIDGET_2':TEACHER_WORKLOAD_WIDGET_2},//职教-教师工作量
  ]
  import TIMETABLE_WIDGET from './widget/timeTable.vue'//课表
  import TRAINING_WIDGET from './widget/training.vue'//培训学习
  import RESOURCE_WIDGET from './widget/resources.vue'//资源中心
  import NETWORK_WIDGRT from './widget/network.vue'//网络研修
  import COURSE_ARRANGE_WIDGET from './widget/teachingschedule.vue'//排课系统
  import COURSE_SELECTION_WIDGET from './widget/electiveCourse.vue'//选课系统
  import PREPARE_WIDGET from './widget/prepar.vue'//协同备课
  import SOCIAL_WIDGET from './widget/social.vue'//网络社交
  import MASTER_STUDIO_MANAGE from './widget/manage.vue'//名师工作室-管理员
  import MASTER_STUDIO_MEMBER from './widget/member.vue'//名师工作室-成员
  import bin_Ding from '../appframe/binding.vue'//添加子女

  import STUDENT_ACHIEVEMENT_WIDGET from './widget/zj_student_achievement.vue'//职教-学生成绩
  import SCHOOL_CALENDAR_WIDGET from './widget/zj_school_calendar.vue'//职教-校历
  import ZJ_COURSE_SELECTION_WIDGET from './widget/zj_elective_course_info.vue'//职教-选修课信息
  import EVALUATION_INFO_WIDGET from './widget/zj_evaluation_info.vue'//职教-评教信息
  import TEACHER_WORKLOAD_WIDGET from './widget/zj_teacher_workload.vue'//职教-教师工作量
  export default {
    components: {
      TIMETABLE_WIDGET,
      TRAINING_WIDGET,
      RESOURCE_WIDGET,
      NETWORK_WIDGRT,
      COURSE_ARRANGE_WIDGET,
      COURSE_SELECTION_WIDGET,
      PREPARE_WIDGET,
      SOCIAL_WIDGET,
      MASTER_STUDIO_MANAGE,
      MASTER_STUDIO_MEMBER,
      STUDENT_ACHIEVEMENT_WIDGET,
      SCHOOL_CALENDAR_WIDGET,
      ZJ_COURSE_SELECTION_WIDGET,
      EVALUATION_INFO_WIDGET,
      TEACHER_WORKLOAD_WIDGET,
      bin_Ding,
    },
    data() {
      return {
        refreshwidget: 1,
        isShowWidgetCont: false,
        widgetList: [],
        isPc: 'pc',
        dialogVisible: false,
        checkDialog: false,
        widgetListUpdate: [],
        gridsterInstance: null,
        widgetListsData: [],
        childrenList:[],
        childrens:{},
        addLoading: false,
        isBinding: false,
        roleTypeId: '',
        roleUserInfo:'',
        imgUrl: window.systemParameter.FILE_SYSTEM_URL + "/api/image/thumbnail/",//图片显示地址
      }
    },
    activated() {
      let vm = this
      this.$nextTick(function () {
        vm.roleTypeId = window.appframe.$store.state.userInfo.roleTypeId
        vm.roleUserInfo = window.appframe.$store.state.userInfo
        vm.query()
        if(vm.roleUserInfo.shortCode == 'P'){
          vm.getUserInfo()
        }
      })
    },
    methods: {
      query() {
        let vm = this
        http.get('/gateway/platform/widget/choosed?roleId=' + vm.roleTypeId).then(function (xhr) {
          vm.widgetListsData = xhr.data.data
          vm.isPc = vm.isPCFn()
          if (vm.isPc == 'phone') {
            //ipad || phone 调整小部件位置，但不保存
            vm.widgetListsData = vm.isAdjust(xhr.data.data)
            vm.isShowWidgetCont = true
          } else {
            vm.$nextTick(function () {
              vm.gridster()
            })
            vm.widgetResize()//窗口变化，改变小部件swWidth
          }
        })
      },
      //绑定学生接口
      getUserInfo(){
        let vm = this
        http.get(globel_url + "/platform/parent/"+vm.roleUserInfo.id+"/children")
          .then(function(xhr) {
            _.each(xhr.data.data,x=>{
              x.checkeds = false
            })
            vm.childrenList = xhr.data.data
            _.each(vm.childrenList,c=>{
              if(c.choosed){
                c.checkeds = c.choosed
                vm.childrens = c
                vm.defaultUserId = c.studentId
              }
            })
            // console.log('vm.childrenList',vm.childrenList,vm.defaultUserId)
          })
      },
      //选中绑定
      changeChildren(c,index){
        let vm = this
        _.each(vm.childrenList,(cd,i)=>{
          if(i == index){
            cd.checkeds = true
          }else{
            cd.checkeds = false
          }
        })

      },
      //切换默认绑定
      checkDefaul(c,index){
        let vm = this
        _.each(vm.childrenList,(cd,i)=>{
          if(i == index){
            cd.choosed = true
          }else{
            cd.choosed = false
          }
        })
        // console.log('切换默认',vm.childrenList)
      },
      //删除已绑定
      delChildren(c,index){
        let vm = this
        const h = this.$createElement;
        this.$confirm(
          '此操作将解除 '+ c.studentName +' , 是否继续?', 
          '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           http.put(globel_url +'/platform/mobile/user/unbind?studentId='+c.studentId+'&parentId='+c.parentId).then(xhr=>{
            if (xhr.data.code) {
              return;
            }
            vm.getUserInfo()
            this.$message({
              type: 'success',
              message: '解绑成功!'
            });
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解绑'
          });          
        });
       
      },
      //设置为已默认绑定学生
      defaultUser(c){
        let vm = this
        http.put(globel_url +'/platform/mobile/user/changeStudent?studentId='+c.studentId+'&parentId='+c.parentId).then(xhr=>{
          if (xhr.data.code) {
            return;
          }
          vm.getUserInfo()
        })
      },
      //确认切换绑定
      enterBtn(){
        let vm = this
        _.each(vm.childrenList,c=>{
          if(vm.defaultUserId != c.studentId){
            if(c.choosed){
              vm.defaultUser(c)
            }
          }
          if(c.checkeds){
            vm.childrens = c
          }
        })
        vm.checkDialog = false
      },
      //解除已绑定
      editChildren(index){
        let vm = this
      },
      //创建新的绑定
      creatNew(){
        let vm = this
        vm.isBinding = true
        vm.checkDialog = false
      },
      backHome(){
        let vm = this
        location.reload(true);
      },
      closedBtn(){
        let vm = this 
        vm.checkDialog = false
      },
      isAdjust(widgetList) {
        let vm = this
        let stemp = []
        let stemp3 = []
        for (let i = 0; i < widgetList.length; i++) {
          if (widgetList[i].swWidth == '2') {
            stemp.push(widgetList[i])
          } else if (widgetList[i].swWidth == '1') {
            stemp.unshift(widgetList[i])
          } else if (widgetList[i].swWidth == '3') {
            stemp3.push(widgetList[i])
          }
        }
        stemp = stemp.concat(stemp3)
        return stemp
      },
      isPCFn() {
        let sUserAgent = navigator.userAgent.toLowerCase();
        let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
        let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        let bIsMidp = sUserAgent.match(/midp/i) == "midp";
        let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
        let bIsAndroid = sUserAgent.match(/android/i) == "android";
        let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
        let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
        let deviceType = ''
        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
          // console.log("您的设备是：phone")
          deviceType = 'phone'
        } else {
          // console.log("您的设备是：pc")
          deviceType = 'pc'
        }
        return deviceType
      },
      widgetResize() {
        $(window).resize(function () {
          // console.log("宽度",$(".widget_list").width())
        })
      },
      gridster() {//小部件拖动方法
        let vm = this
        vm.isShowWidgetCont = false
        if (vm.gridsterInstance) {
          vm.gridsterInstance = null
        }
        let $el = $(this.$refs.widget)
        let gridster = $('.gridster ul').gridster({
          widget_margins: [30, 30],
          max_cols: 3, //最多能创建多少列
          widget_base_dimensions: ['auto', 328],
          shift_widgets_up: false,
          shift_larger_widgets_down: false,
          collision: {
            wait_for_mouseup: true
          },
          resize: {
            enabled: false
          },
          serialize_params: function ($w, wgd) {
            return {
              col: wgd.col,
              row: wgd.row,
              size_x: wgd.size_x,
              size_y: wgd.size_y,
              equip: wgd.el[0].dataset.equip
            }
          },
          draggable: {
            stop(e, ui) {
              
              let widgetName = ui.$player[0].attributes['widget-name'].value
              let col = ui.$player[0].attributes['data-row'].value
              let row = ui.$player[0].attributes['data-col'].value
              let flag = false
              for(let i=0;i<vm.widgetListsData.length;i++){
                let temp = vm.widgetListsData[i]
                if(widgetName == temp.swCode){
                  let positionX = temp.positionX
                  let positionY = temp.positionY
                  if(positionX != col){
                    flag = true
                  }
                  if(positionY != row){
                    flag = true
                  }
                }
              }
              // console.log("是否改变位置",flag)
              if(flag)
              vm.saveWidget('draggable')
            }
          }
        })
        vm.gridsterInstance = gridster.data('gridster')
        vm.$nextTick(function () {
          vm.isShowWidgetCont = true
        })
      },
      showWeightAdd() {//显示添加小部件弹窗
        let vm = this
        vm.dialogVisible = true
        vm.addLoading = true
        http.get('/gateway/platform/widget/default?roleId=' + vm.roleTypeId).then(function (xhr) {
          if (xhr.data.data) {
            vm.addLoading = false
            _.each(xhr.data.data, function (v) {
              if (v.swWidth == 0) {
                v.swWidth = 1
              }
              //这些小部件没得切换尺寸
              // STUDENT_ACHIEVEMENT_WIDGET,
              // SCHOOL_CALENDAR_WIDGET,
              // ZJ_COURSE_SELECTION_WIDGET,
              // EVALUATION_INFO_WIDGET,
              // TEACHER_WORKLOAD_WIDGET

              if(v.swCode == 'TEACHER_WORKLOAD_WIDGET' || v.swCode == 'EVALUATION_INFO_WIDGET'){
                v.swWidth = 2
                v.isType = true
              }
              if(v.swCode == 'SCHOOL_CALENDAR_WIDGET'){
                v.swWidth = 3
                v.isType = true
              }if(v.swCode == 'STUDENT_ACHIEVEMENT_WIDGET' || v.swCode == 'ZJ_COURSE_SELECTION_WIDGET'){
                v.isType = true
              }

              _.each(vm.widgetListsData, function (m) {
                if (v.swId == m.swId) {
                  v.swWidth = m.swWidth
                }
              })
            })
            vm.widgetListUpdate = xhr.data.data
          }
        })
      },
      sureUpdate() {//确认添加小部件
        let vm = this
        vm.dialogVisible = false
        if (vm.gridsterInstance) {
          vm.gridsterInstance.destroy()
        }
        _.each(vm.widgetListUpdate, function (v) {
          let isHave = false
          for(let i=0;i<vm.widgetListsData.length;i++){
            let m = vm.widgetListsData[i]
            if (v.swId == m.swId) {
              isHave = true
              m.swWidth = v.swWidth
              m.isAdd = v.isAdd
            }
          }
          if(!isHave){
            vm.widgetListsData.push(v)
          }
        })

        vm.$nextTick(function () {
          vm.gridster()
          setTimeout(() => {
            vm.saveWidget()
          }, 1000)
        })
      },
      saveWidget(drag) {//保存
        let vm = this
        let $el = $(vm.$refs.widget)
        let list = $el.children('.gs-w')
        list = _.map(list, function (vv) {
          vv = $(vv)
          return {
            'roleTypeId': window.appframe.$store.state.userInfo.roleTypeId,
            'userId': window.appframe.$store.state.userInfo.id,
            'srId': vv.attr('srId'),
            'suId': vv.attr('suId'),
            'swId': vv.attr('swId'),
            'swCode': vv.attr('swCode'),
            'positionY': vv.attr('data-col'),
            'positionX': vv.attr('data-row'),
            'swWidth': vv.attr('data-sizex') == 0 ? 1 : vv.attr('data-sizex'),
          };
        })
        http.post(InterfacePrefix['platform'] + '/widget/' + vm.roleTypeId, list).then(function (xhr) {
          //改变位置后查询
          if (!drag) {
            if (vm.gridsterInstance) {
              vm.gridsterInstance.destroy()
            }
            vm.refreshwidget = Math.random()
            vm.$nextTick(i => {
              vm.query()
            })
          }
        })
      },
      imgsrc(name, type) {
        let stemp = name+'_'+type
        let url = ''
        for(let i=0;i<imgArr.length;i++){
         if(imgArr[i][stemp])
         url = imgArr[i][stemp]
        }
        return url
      }
    },
  }

</script>
<style scoped lang="less">
  .phone_weight.widget_list {
    padding: 15px;
    [data-size='1'] {
      width: calc(~'50% - 30px');
    }
    [data-size='2'],
    [data-size='3'] {
      width: calc(~'100% - 30px');
    }
    .widget_item {
      margin: 15px;

    }
  }
  
  .binding{ 
    margin: 16px 12px 0; 
    height: 98px; 
    border: 1px solid #e5e7ea; 
    border-radius: 8px; 
    background: #fff;
    padding: 13px 31px;
    box-sizing: border-box;
    .user_img{ width: 70px; height: 70px; overflow: hidden; background: #fff; float: left;
      >img{ width: 70px; height: 70px; border-radius: 50%; }
    }
    .user_info{ padding-left: 16px; background: #fff; float: left;
      >p:first-child{ font-size: 18px; color: #333; font-weight: 700; margin: 7px 0 14px; }
      >p{ font-size: 14px; color: #999; }
    }
    .user_btn{ float: right; margin-top: 19px; background: #fff; }
  }
  .childrenList{ margin-bottom: 24px; height: 120px;
    .el_checkbox{ float: left; margin: 52px 10px;  }
    .list_children{ width: 604px; margin-left: 50px; box-sizing: border-box; padding: 15px; height: 120px; 
      border-radius: 8px; position: relative; overflow: hidden;
      .list_label{ position: absolute; right: -32px; top: 10px; width: 100px; height: 24px;
        font-size: 14px; color: #fff; text-align: center; transform: rotate(45deg)}
      .defaul_color{ background: #fcbe27; }
      .creat_color{ background: #1cd979; }
      .list_img{ float: left; margin-left: 16px; height: 70px; width: 70px; margin-top: 9px;
        >img{ height: 70px; width: 70px; border-radius: 50%; }
      }
      .list_info{ color: #fff; padding-left: 102px; height: 52px; margin-top: 20px;

        >p:first-child{ font-size: 18px; font-weight: 700; margin-bottom: 4px; }
        >p{ font-size: 14px; }
      }
      .list_btn{ text-align: right; color: #fff; margin-top: -4px;
        >span{ margin-left: 14px; cursor: pointer;
          >i{ margin-right: 4px; }
          .checkBoxBorder{ width:10px; height: 10px; border: 2px solid #fff; font-size: 12px;}
        }
      }
    }
  }
  .childrenList>.el_checkbox>.el-radio__label,.list_btn>span>.el-checkbox>.el-checkbox__label{ color: #fff; }
  .listDefaul{ background: url('./img/default.png'); }
  .listOthers{ background: url('./img/checked.png'); }
  .lislCreat{ background: url('./img/creat.png'); }
  .widget_list {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    &>ul {
      min-width: 750px!important;
    }
    .widget_item {
      background: #fff;
      border-radius: 8px;
      display: inline-block;
      vertical-align: top;
      box-sizing: border-box;
      padding: 20px 24px;
      vertical-align: top;
    }
  }

  .add_bar {
    position: fixed;
    bottom: 50px;
    right: 50px;
    color: #ccc;
    font-size: 50px;
    cursor: pointer;
    z-index: 1000;
  }

  .add_bar:hover {
    color: #1A85ED;
  }

  .add_weight {
    display: flex;
    flex-wrap: wrap;
    max-height: 480px;
    overflow: auto;
  }

  .add_weight_list {
    min-width: 168px;
    width: 23%;
    margin: 10px 1%;
    padding: 10px;
    background: #EEEFF0;
    position: relative;
    .widget_img {
      height: 120px;
      line-height: 120px;
      margin: 10px 0;
    }
    img {
      vertical-align: middle;
      width: 100%;
      max-width: 100%;
      max-height: 100%;
    }
    .weight_name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 30px;
      margin-right: 40px;
    }
    .weight_chose {
      text-align: center;
      span {
        background: #ccc;
        padding: 2px 5px;
        font-size: 12px;
        margin-top: 2px;
        display: inline-block;
        vertical-align: top;
        cursor: pointer;
        border-radius: 2px;
      }
      span:hover {
        background: #1A85ED;
        color: #fff;
      }
      span.is_active {
        background: #409eff;
        color: #fff;
      }
    }
    .weight_bar {
      width: 60px;
      line-height: 24px;
      text-align: center;
      border-radius: 3px;
      cursor: pointer;
      display: inline-block;
      vertical-align: top;
      i {
        font-weight: bold;
        margin-right: 5px;
      }
    }
    .remove_btn {
      color: #fa5555;
      background: #fee;
      border: 1px solid #fdbbbb;
    }
    .add_btn {
      color: #fff;
      background: #409eff;
      border: 1px solid #409eff;
    }
    .check {
      width: 0;
      height: 0;
      border-width: 40px 0px 0px 40px;
      border-style: solid;
      border-color: #FFD200 transparent transparent transparent;
      position: absolute;
      right: 1px;
      top: 1px;
      .el-icon-check {
        color: #fff;
        font-size: 20px;
        position: absolute;
        top: -35px;
        right: 0;
      }
    }
  }
  .noData{
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/homepage/index.vue